import config from '../config';

/**
 * Use this class to ensure Google Maps API javascript is loaded before running any google map specific code.
 * Based on https://gist.github.com/mavame/b833b50085dc856acbccbb34ab1dbe92
 */
export default class GoogleMapsApi {
    /**
     * Constructor set up config.
     */
    constructor() {
        // api key for google maps
        this.apiKey = config.googleMapsApiKey;

        // set a globally scoped callback if it doesn't already exist
        if (process.title === 'browser' && !window._GoogleMaps) {
            this.callbackName = '_GoogleMaps.mapLoaded';
            window._GoogleMaps = this;
            window._GoogleMaps.mapLoaded = this.mapLoaded.bind(this);
        }
    }

    /**
     * Load the Google Maps API javascript
     */
    load() {
        if (!this.promise) {
            this.promise = new Promise(resolve => {
                this.resolve = resolve;
                if (process.title === 'browser' && typeof window.google === 'undefined') {
                    const script = document.createElement('script');
                    script.src = `//maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=${this.callbackName}&language=sv`;
                    script.async = true;
                    document.body.append(script);
                } else {
                    this.resolve();
                }
            });
        }

        return this.promise;
    }

    /**
     * Globally scoped callback for the map loaded
     */
    mapLoaded() {
        if (this.resolve) {
            this.resolve();
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/google-maps-api.js